export default "__VITE_ASSET__YXqJWHa9__"